<ng-template #passSection>
    @if (subscriptionSavings) {
        <div class="subscription-savings center">
            Congrats! You've saved {{ subscriptionSavings | rupee }} with
            <img src="{{ DEPLOY_URL }}/assets/images/membership_logo.png" style="height: 20px" alt="EatClub Logo" />
        </div>
    }

    @if (cartHasPass) {
        <div class="pass-section">
            <img src="{{ DEPLOY_URL }}/assets/images/EC logo white.svg" />
            <div style="width: 100%">
                <div class="section-top">
                    <span>{{ cartHasPass.label }}</span>
                    <div>
                        @if (cartHasPass.marked_price > cartHasPass.price) {
                            <span>
                                <span class="strikethrough">&#8377;&nbsp;{{ cartHasPass.marked_price }}&nbsp;</span>
                            </span>
                        }
                        @if (cartHasPass.price) {
                            <span>&#8377;&nbsp;{{ cartHasPass.price }}</span>
                        } @else {
                            <span>FREE</span>
                        }
                    </div>
                </div>
                <div class="section-bottom">
                    <span class="change-plan" (click)="openPassDialog()">Change Plan</span>
                    <span class="remove-pass" (click)="removePass(cartHasPass)">REMOVE</span>
                </div>
            </div>
        </div>
    }
</ng-template>

<div class="cart-items adjust-width">
    @if (cartHasPass || subscriptionSavings) {
        <ng-container *ngTemplateOutlet="passSection"></ng-container>
    }

    @if (loading) {
        <div class="multi-brand-cart">
            @for (_ of [].constructor(1); track _) {
                <div class="brand-container" style="height: 150px; gap: 6px">
                    <app-selector [height]="'20px'" [width]="'40%'"></app-selector>
                    <app-selector [height]="'20px'" [width]="'100%'"></app-selector>
                    <app-selector [height]="'30px'" [width]="'100%'"></app-selector>
                </div>
            }
        </div>
    }
    @if (!loading) {
        <div class="multi-brand-cart">
            @for (state of brandState | keyvalue: unsorted; track state) {
                @if (state.value.size) {
                    @if (state.key === 'preorder' || state.key === 'closed') {
                        <div class="status-container">
                            <span class="status-text">
                                {{ state.key === 'preorder' ? 'PREORDER ONLY' : 'CURRENTLY UNAVAILABLE' }}
                            </span>
                            <span class="remove-from-cart" (click)="removeAllItems([state.key])"> REMOVE FROM CART </span>
                        </div>
                    }
                }
                @for (brand of brand_details | brandState: state.value; track brand) {
                    <div
                        class="brand-container"
                        [class.closed]="state.key === 'closed'"
                        (click)="state.key === 'closed' && removeInActiveBrands()">
                        <div class="brand-header">
                            <span class="brand-name">
                                {{ brand.brand_name }}
                            </span>
                            @if (outlet_closing_timer[brand.brand_id]?.isClosing) {
                                <span class="closing-text">
                                    <img src="{{ DEPLOY_URL }}/assets/images/closing_timer.svg" />
                                    Closing in {{ outlet_closing_timer[brand.brand_id]?.totalTime }}
                                </span>
                            }
                            @if (state.key === 'preorder' && outlet_opening_timing[brand.brand_id]?.openingTime; as openingTime) {
                                <span class="opening-text">
                                    <img src="{{ DEPLOY_URL }}/assets/images/opening_timer.svg" />
                                    {{ openingTime }}
                                </span>
                            }
                        </div>
                        @for (
                            item of serverCartData | brandProductFilter: brand.brand_id : true : samplingProductsIds;
                            track item
                        ) {
                            <ng-container
                                *ngTemplateOutlet="cartItemWrapper; context: { item_type: 'menu', item }"></ng-container>
                        }
                    </div>
                }
                <!-- Sampling/ Freebie/ FreeItem-->
                @if (state.key === 'normal' && (samplingItems.length || freeItems.length)) {
                    <div class="brand-container">
                        <span class="brand-name">
                            {{ freeItems[0]?.brand_name || samplingItems[0]?.brand_name }}
                            <img src="{{ DEPLOY_URL }}/assets/images/goodies.svg" />
                        </span>
                        @for (item of samplingItems; track item) {
                            <ng-template
                                [ngTemplateOutlet]="cartItemWrapper"
                                [ngTemplateOutletContext]="{ item_type: item.item_type, item }"></ng-template>
                        }
                        @for (item of freeItems; track item) {
                            <ng-template
                                [ngTemplateOutlet]="cartItemWrapper"
                                [ngTemplateOutletContext]="{ item_type: 'free', item }"></ng-template>
                        }
                    </div>
                }
            }
        </div>
    }
</div>

<ng-template #cartItemWrapper let-item="item" let-item_type="item_type">
    <div class="cart-item-wrapper">
        <!-- TODO: handling of soldout freebie and sampling properly 30/09/24 -->
        <div class="row" [class.closed]="item_type === 'menu' && unavailableItems[item.id]?.type === 'item'" style="border: none">
            <div class="col-xs-8 col-sm-8">
                <h3 class="size-description">
                    @if (item_type !== 'free' && item_type !== 'sampling') {
                        <div [ngClass]="{ veg: item.is_veg, 'non-veg': !item.is_veg }"></div>
                    } @else {
                        <img class="gift-img" src="{{ DEPLOY_URL }}/assets/images/gift.svg" />
                    }
                    <span class="product-label">{{ item?.label }}</span>
                </h3>

                <div style="margin-left: 21px">
                    @if ((item.description | typeof) === 'object') {
                        <div class="combo-description">
                            @for (desc of item.description | keyvalue; track desc) {
                                <div class="description-container">
                                    <div
                                        class="desc-icon"
                                        [ngClass]="{
                                            veg: item?.description[desc.key].veg,
                                            'non-veg': !item?.description[desc.key].veg
                                        }"></div>
                                    @if (item?.description[desc.key].label.join(', '); as description) {
                                        <p class="product-description">
                                            {{ description }}
                                        </p>
                                    }
                                    @if (item?.description[desc.key].remarks; as remarks) {
                                        <span class="desc-remarks">
                                            {{ remarks }}
                                        </span>
                                    }
                                </div>
                            }
                        </div>
                    }
                    @if ((item.description | typeof) === 'string') {
                        <p class="product-description">
                            {{ item?.description }}
                        </p>
                    }
                    @if (item?.is_customizable) {
                        <i>
                            <p (click)="customize(item)" class="section-header">Tap to Customize</p>
                        </i>
                    }
                </div>
            </div>

            <div class="col-xs-4 col-sm-4">
                <div class="pull-right pricing">
                    @if (item.marked_price > item.price) {
                        <span class="strikethrough"> &#8377;&nbsp;{{ item.marked_price }} </span>
                    }
                    @if (item_type === 'menu') {
                        <span>&#8377;&nbsp;{{ item.price }}</span>
                    }
                    @if (item_type !== 'menu') {
                        <span class="free-label">FREE</span>
                    }
                </div>
                <div class="clearfix"></div>
                <div class="space-5"></div>
                @if (item_type === 'menu') {
                    <div class="pull-right">
                        <ui-counter-button
                            [counter]="item.quantity"
                            [customStyles]="{ height: '35px', width: '75px' }"
                            (onCounterChange)="updateCart($event, item)">
                        </ui-counter-button>
                    </div>
                }
                @if (item_type === 'freebie' || item_type === 'sampling') {
                    <div class="pull-right pricing">
                        @if (!samplingProductLabel(item.ids.product_size_id)) {
                            <button (click)="toggleSamplingItem(item, 'ADD')" class="freebie-action-btn">ADD +</button>
                        }
                        @if (samplingProductLabel(item.ids.product_size_id)) {
                            <button (click)="toggleSamplingItem(item, 'REMOVE')" class="freebie-action-btn">REMOVE</button>
                        }
                    </div>
                }
            </div>
        </div>

        @if (item_type === 'menu') {
            <app-cart-view-item-error
                [item]="unavailableItems[item.id] || {}"
                (reviewItem)="reviewItem($event, item)"></app-cart-view-item-error>
        }
    </div>
</ng-template>
